export const ROLES = {
  END_USER: 'END_USER',
  STAFF: 'STAFF',
  SUPER_ADMIN: 'SUPER_ADMIN',
};

export function normalizeRole(raw) {
  if (!raw) return ROLES.END_USER;
  const s = String(raw).trim().toUpperCase().replace(/-/g, '_');
  if (s === 'SUPER_ADMIN' || s === 'ADMIN') return ROLES.SUPER_ADMIN;
  if (s === 'STAFF') return ROLES.STAFF;
  if (s === 'END_USER' || s === 'VIEWER' || s === 'USER') return ROLES.END_USER;
  return ROLES.END_USER;
}

export function isStaffOrAbove(role) {
  const r = normalizeRole(role);
  return r === ROLES.STAFF || r === ROLES.SUPER_ADMIN;
}

export function isSuperAdmin(role) {
  return normalizeRole(role) === ROLES.SUPER_ADMIN;
}

export function isEndUser(role) {
  return normalizeRole(role) === ROLES.END_USER;
}
